///
/// EarthBrowser
///
/// Migration v51 to v52: Remove terrain rendering settings
/// Created by Matt Giger on 10/16/2026
/// Copyright (c) 2026 Geodata Labs
///

/**
 * Migration: v51 to v52
 *
 * Changes:
 * - Drops earthbrowser.terrainSettings. The Layers panel terrain controls
 *   were removed; the engine renders at the fixed defaults (1.2x vertical
 *   exaggeration, sunrise/sunset relief light on), so a persisted
 *   non-default value must not linger.
 */
export function migrateV51toV52(state: unknown): unknown {
	const s = state as Record<string, unknown> | null | undefined
	if (!s || typeof s !== "object" || !s.earthbrowser) return state

	const eb = { ...(s.earthbrowser as Record<string, unknown>) }
	delete eb.terrainSettings
	return { ...s, earthbrowser: eb }
}
